<template>
  <div class="operaGuideline">
   <!-- 操作指引 -->
   <card-plate title="操作指引">
     <span slot="headMore" @click="toPath('/helpCenter')"><span>更多>></span></span>
     <ul slot="headCont" class="list">
       <li :key="item.columnId" v-for="item in columnDtos||[]" @click="toPath('/helpDetails',{columnId:item.columnId})"><div class="mr8"><img src="../../../assets/images/czzy_icon.svg" alt=""></div><div>{{item.columnName}}</div></li>
       <!-- <li><span class="mr8"><img src="../../../assets/images/czzy_icon.svg" alt=""></span><span>征信报告操作指引</span></li>
       <li><span class="mr8"><img src="../../../assets/images/czzy_icon.svg" alt=""></span><span>通用板块供应商报名</span></li> -->
        <empty-tab v-if="(columnDtos&&columnDtos.length==0)||!columnDtos"></empty-tab>
     </ul>
   </card-plate>
  </div>
</template>
<script>
import cardPlate from './cardPlate.vue'
import emptyTab from './emptyTab.vue'
export default {
  props: ['columnDtos'],
  components: {
    'card-plate': cardPlate,
    'empty-tab': emptyTab
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {

    toPath(url,params={}){
      // 操作指引 http://test.onelinkplus.com/helpDetails?columnId=5866045933602471936
      if (url.indexOf('http://') > -1 || url.indexOf('https://')) {
        window.open(url, '_blank');
      } else {
        let routeData = this.$router.resolve({
          path: url,
          query:params
        });
        window.open(routeData.href, '_blank');
      }
    }

  }
}
</script>
<style>
.operaGuideline .cardPlate-cont{
  max-height: 265px;
  overflow: auto;
}
.operaGuideline .cardPlate-cont::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

.operaGuideline .cardPlate-cont::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.operaGuideline .cardPlate-cont::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgba(0,0,0,0.3);
}

.operaGuideline .cardPlate-cont::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0,0,0,0.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/operaGuideline.vue